import React from 'react';
import { PropertyEdit } from '@v2/components/flowsteps/editors/PullOjbectHS/PropertyEdit/PropertyEdit';
import CellPicker from 'src/components/base/CellPicker';
import { Checkbox } from '@fluentui/react';
import { PullOptionsState } from './pull-options-state';
import { useStyles } from './PullOptions.styles';
import { observer } from "mobx-react";

interface PullOptionsProps {
  state: PullOptionsState;
}

export const PullOptions: React.FC<PullOptionsProps> = observer(({ state }) => {
  const styles = useStyles();

  return (<>
    <div className={styles.options}>
      <PropertyEdit label="Table start cell" tooltip="The address of the left top cell of the range where the data will be placed">
        <CellPicker
          value={state.startCell}
          onChange={(address: string) => {
            state.startCell = address;
          }}
          disabled={false}
        />
      </PropertyEdit>
      <PropertyEdit
        label="Create data table"
        tooltip={`Creates an Excel Data Table around the pulled data, which enhances the visual 
                 representation of the data and allows easier use of data with multiple excel functions`}
      >
        <Checkbox
          checked={state.createExcelTable}
          onChange={(_, checked) => state.createExcelTable = !!checked}
        />
      </PropertyEdit>
      <PropertyEdit
        label="Create drop-downs in picklist columns"
        tooltip={`Check this box if you'd like us to create Excel Data Validation controls (drop down boxes) 
                 in each cell of the columns pulled from picklists and populate them with picklist values`}
      >
        <Checkbox
          checked={state.createDropDowns}
          onChange={(_, checked) => state.createDropDowns = !!checked}
        />
      </PropertyEdit>
    </div>
  </>)
})
